export default [
  {
    path: '/customer',
    component: () => import('./Customer'),
    children: [
      {
        path: 'pushNotifications',
        component: () => import('./push-notifications/PushNotifications'),
        name: 'pushNotifications'
      }
    ]
  }
]
